import React, { useState, useEffect } from "react";
import img1 from "../assetsproduct/innov1.png";
import img3 from "../assetsproduct/innov3.png";
import img4 from "../assetsproduct/innov4.png";
import img6 from "../assetsproduct/innov6.png";
import img7 from "../assetsproduct/innov7.png";
import img8 from "../assetsproduct/innov8.png";
import img9 from "../assetsproduct/innov9.png";
import "../ProductPagecommon.css";
import "./Innovation.css";

const cardsData = [
  { img: img3, title: "Healthcare & Life Sciences" },
  { img: img4, title: "Finance & Banking" },
  { img: img1, title: "E-commerce & Retail" },
  { img: img6, title: "Education & E-Learning" },
  { img: img7, title: "Travel & Hospitality" },
  { img: img8, title: "Logistics & Supply Chain" },
  { img: img9, title: "Media & Entertainment" },
];

export default function Innovation() {
  const [active, setActive] = useState(cardsData.length);
  const [cardsPerView, setCardsPerView] = useState(5);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 576) {
        setCardsPerView(2);
        setActive(cardsData.length);
      }
          else if (window.innerWidth <= 768) {
        setCardsPerView(3);
        setActive(cardsData.length);
      } else if (window.innerWidth <= 992) {
        setCardsPerView(4);
        setActive(cardsData.length);
      } else {
        setCardsPerView(5);
        setActive(cardsData.length);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const infiniteCards = [...cardsData, ...cardsData, ...cardsData];
  const cardWidth = 100 / cardsPerView;

  const handleDotClick = (index) => {
    setIsTransitioning(true);
    setActive(cardsData.length + index);
  };

  const handleTransitionEnd = () => {
    setIsTransitioning(false);
    if (active >= cardsData.length * 2) {
      setActive(cardsData.length);
    } else if (active < cardsData.length) {
      setActive(cardsData.length);
    }
  };

  const isFirstVisibleCard = (index) => {
    return (index - active) % cardsPerView === 0 && index >= active && index < active + cardsPerView;
  };

  return (
    <div id="product-innovation" className="productmainclass">
      <h2 className="heading">Our Work Across Industries</h2>
      <p className="subheading">
       We empower businesses with custom industry-specific CRMs that streamline processes, improve customer engagement, and drive measurable growth.
      </p>

      <div className="cards">
        <div
          className="cards-track"
          style={{ 
            transform: `translateX(-${active * cardWidth}%)`,
            transition: isTransitioning ? 'transform 0.4s ease' : 'none'
          }}
          onTransitionEnd={handleTransitionEnd}
        >
          {infiniteCards.map((item, index) => (
            <div 
              className={`card ${isFirstVisibleCard(index) ? 'first-visible' : ''}`}
              key={index} 
              style={{ 
                width: `${cardWidth}%`,
                flexShrink: 0
              }}
            >
              <img src={item.img} alt="" />
              <span>{item.title}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="dots">
        {cardsData.map((_, index) => (
          <span
            key={index}
            className={`dot ${(active % cardsData.length) === index ? "active" : ""}`}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>
    </div>
  );
}